import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC014_Request,
  IAPI_ACC014_Response,
} from "../../../type/apiType";

// 退職者認証
const httpAPI_ACC014 = async (
  param: IAPI_ACC014_Request
): Promise<IAPI_ACC014_Response> => {
  let res = await http.post(ApiUrl.API_ACC014, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC014 };
